module.exports = __webpack_public_path__ + "img/shrimp-desktop.97bf22ba.png";